import { lazy } from 'react';

export * from './routes';

export const SivaAdminFeature = lazy(() => import('./pages/SivaAdminFeature'));
